import Home from '@/views/Home';
import About from '@/views/About';
import Terms from '@/views/Terms';
import PageNotFound from '@/views/PageNotFound';
import Jobs from '@/views/common/Jobs';
import DeliveryJobs from '@/views/common/DeliveryJobs';
import Crew from '@/views/common/Crew';
import UserDetails from '@/views/common/UserDetails';
import PersonalInfo from '@/views/common/PersonalInfo';
import Settings from '@/views/common/Settings';

export default [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { requiresAuth: false },
  }, {
    path: '/terms',
    name: 'terms',
    component: Terms,
    meta: { requiresAuth: false },
  }, {
    path: '/about',
    name: 'about',
    component: About,
    meta: { requiresAuth: false },
  }, {
    path: '/jobs',
    name: 'jobs',
    component: Jobs,
    meta: { requiresAuth: false },
  }, {
    path: '/delivery',
    name: 'delivery',
    component: DeliveryJobs,
    meta: { requiresAuth: false },
  }, {
    path: '/users/:type',
    name: 'users',
    component: Crew,
    meta: { requiresAuth: false },
  }, {
    path: '/user/:id',
    name: 'user-details',
    component: UserDetails,
    meta: { requiresAuth: false },
  },
  {
    path: '/personal-info',
    name: 'personal-info',
    component: PersonalInfo,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: { requiresAuth: true },
  },
  { path: '*', component: PageNotFound },
  { path: '/not-found', name: 'not-found', component: PageNotFound },
];
